@if (items().length) {
  <div #itemsContainer class="toc-items-container">
    <!-- Depth-aware line: gray background + blue active thumb, both use same SVG path -->
    @if (svgData(); as svg) {
      <div
        class="toc-line-container"
        [style.width.px]="svg.width"
        [style.height.px]="svg.height"
      >
        <!-- Gray background line -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          [attr.viewBox]="'0 0 ' + svg.width + ' ' + svg.height"
          [style.width.px]="svg.width"
          [style.height.px]="svg.height"
          class="toc-line-bg"
        >
          <path
            [attr.d]="svg.path"
            [attr.stroke-width]="lineStrokeWidth"
            stroke="var(--neutral-200)"
            fill="none"
          ></path>
        </svg>

        <!-- Blue active thumb (masked to SVG path shape) -->
        <div class="toc-thumb-mask" [style.mask-image]="svgMaskImage()">
          <div
            class="toc-thumb"
            [style.margin-top.px]="thumbTop()"
            [style.height.px]="thumbHeight()"
          ></div>
        </div>
      </div>
    }

    @for (item of items(); track item.id) {
      <a
        class="toc-item"
        [attr.data-toc-item-id]="item.id"
        [attr.data-active]="item.isActive"
        [style.padding-inline-start.px]="getItemOffset(item.level)"
        (click)="onItemClick(item.id)"
      >
        <dojo-markdown-viewer [content]="item.textContent" class="latex-sample" />
      </a>
    }
  </div>
}
